import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { translate } from 'react-i18next';

import { theme } from 'lib/styles';

const Container = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingText = styled.h1`
  color: ${props => props.theme.heading};
`;

const HeaderContainer = styled.div`
	background-color: white;
	box-shadow: 0px 2px 4px 0px rgba(120,120,120,0.1);

	height: 60px;
	margin-bottom: 73px;
`;

const Loading = props => {
	const { t } = props;

	return (
		<ThemeProvider theme={theme}>
			<Container>
				<LoadingText>{t('app/Loading')}</LoadingText>
			</Container>
		</ThemeProvider>
	);
}

Loading.propTypes = {
	t: PropTypes.any,
}

// BROWSE

const BrowseContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: ${props => props.browseType === 'tile' ? 'flex-start' : 'center'};

	padding: 0 0 40px 40px;
`;

const BrowseItem = styled.div`
	background-color: white;
	box-shadow: 0 2px 3px 0 rgba(0,0,0,0.2);

	min-height: 300px;
	margin: 0 40px 40px 0;
	width: ${props => props.browseType === 'tile' ? 'calc(20vw - 54px)' : '100%'};
	max-width: 90vw;
	opacity: 0.1;

	animation: pulse 1s ease-in-out forwards infinite;

	&:nth-child(1n+1) { animation-delay: 0.0s; }
	&:nth-child(2n+2) { animation-delay: 0.1s; }
	&:nth-child(3n+3) { animation-delay: 0.2s; }
	&:nth-child(4n+4) { animation-delay: 0.3s; }
	&:nth-child(5n+5) { animation-delay: 0.4s; }
	&:nth-child(6n+6) { animation-delay: 0.5s; }
	&:nth-child(7n+7) { animation-delay: 0.6s; }
	&:nth-child(8n+8) { animation-delay: 0.7s; }
	&:nth-child(9n+9) { animation-delay: 0.8s; }
	&:nth-child(10n+10) { animation-delay: 0.9s; }
	&:nth-child(11n+11) { animation-delay: 1.0s; }
	&:nth-child(12n+12) { animation-delay: 1.1s; }
	&:nth-child(13n+13) { animation-delay: 1.2s; }
	&:nth-child(14n+14) { animation-delay: 1.3s; }
	&:nth-child(15n+15) { animation-delay: 1.4s; }
	&:nth-child(16n+16) { animation-delay: 1.5s; }

	@media (max-width: 2000px) {
		width: ${ props => props.browseType === 'tile' ? 'calc(25vw - 54px)' : '100%' };
	}

	@media (max-width: 1700px) {
		width: ${ props => props.browseType === 'tile' ? 'calc(33vw - 55px)' : '100%' };
	}

	@media (max-width: 1200px) {
		width: ${ props => props.browseType === 'tile' ? 'calc(50vw - 70px)' : '100%' };
	}

	@keyframes pulse {
		0% {
			opacity: 0.1;
		}
		80% {
			opacity: 0.6;
		}
		100% {
			opacity: 0.1;
		}
	}
`;

export default translate('translations')(Loading)

export {
	Container,
	LoadingText,
	HeaderContainer,
	BrowseContainer,
	BrowseItem,
}
